module.exports = __webpack_public_path__ + "img/clothing99.8c78bae3.jpg";